import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import ShortText from './ShortText'
import LongText from './LongText'
import DropDown from './DropDown'
import Email from './Email'
import Phone from './Phone'

const MuseumArtifactDonationForm = () => {


    const currentConditionData = [
        'عالی',
        'خوب',
        'نسبتا خوب',
        'ضعیف',
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم اهدای آثار موزه'} subHeader={'از اینکه قصد اهدای آثار باستانی به موزه ما را دارید متشکریم. لطفاً فرم زیر را با جزئیات آثار باستانی که مایل به اهدای آنها هستید، پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <ShortText header={'نام مصنوع'} />
                <LongText header={'توضیحات'}/>
                <DropDown header={'وضعیت فعلی'} options={currentConditionData}/>
                <LongText header={'منشأ'}/>
                <FullName header={'نام اهدا کننده'} />
                <Email header={'ایمیل'} />
                <Phone header={'شماره تلفن'} />
            </Grid>
        </Grid>
    )
}

export default MuseumArtifactDonationForm
